// src/views/folders/slice/selectors.ts
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../redux/store';
import slice from './slice';

// ✅ Podstawowe selektory (bez zmian)
export const getFolderTree = (state: RootState) => state[slice.name].folderTree;
export const getFolderTreeWithLists = (state: RootState) => state[slice.name].folderTreeWithLists;
export const getIsLoadingTree = (state: RootState) => state[slice.name].isLoadingTree;
export const getExpandedFolders = (state: RootState) => state[slice.name].expandedFolders;
export const getIsCreatingFolder = (state: RootState) => state[slice.name].isCreatingFolder;
export const getIsMovingItem = (state: RootState) => state[slice.name].isMovingItem;
export const getIsRenamingItem = (state: RootState) => state[slice.name].isRenamingItem;
export const getIsDeletingFolder = (state: RootState) => state[slice.name].isDeletingFolder;

// ✅ NOWE - Zmemoizowane selektory
export const getFolderTreeState = createSelector(
  [getFolderTreeWithLists, getExpandedFolders, getIsLoadingTree],
  (tree, expanded, loading) => ({
    folderTreeData: tree,
    expandedFolders: expanded,
    isLoading: loading,
  }),
);

export const getOperationsState = createSelector(
  [getIsCreatingFolder, getIsMovingItem, getIsRenamingItem, getIsDeletingFolder],
  (creating, moving, renaming, deleting) => ({
    isCreating: creating,
    isMoving: moving,
    isRenaming: renaming,
    isDeleting: deleting,
  }),
);

// // src/views/folders/slice/selectors.ts
// import { RootState } from '../../../redux/store';
// import slice from './slice';

// export const getFolderTree = (state: RootState) => state[slice.name].folderTree;
// export const getFolderTreeWithLists = (state: RootState) => state[slice.name].folderTreeWithLists;
// export const getIsLoadingTree = (state: RootState) => state[slice.name].isLoadingTree;
// export const getTreeError = (state: RootState) => state[slice.name].treeError;
// export const getIsCreatingFolder = (state: RootState) => state[slice.name].isCreatingFolder;
// export const getCreateFolderError = (state: RootState) => state[slice.name].createFolderError;
// export const getIsDeletingFolder = (state: RootState) => state[slice.name].isDeletingFolder;
// export const getDeleteFolderError = (state: RootState) => state[slice.name].deleteFolderError;
// export const getIsMovingItem = (state: RootState) => state[slice.name].isMovingItem;
// export const getMoveItemError = (state: RootState) => state[slice.name].moveItemError;
// export const getIsRenamingItem = (state: RootState) => state[slice.name].isRenamingItem;
// export const getRenameItemError = (state: RootState) => state[slice.name].renameItemError;
// export const getExpandedFolders = (state: RootState) => state[slice.name].expandedFolders;
// export const getSelectedItem = (state: RootState) => state[slice.name].selectedItem;
// export const getCurrentFolderId = (state: RootState) => state[slice.name].currentFolderId;
// export const getBreadcrumbs = (state: RootState) => state[slice.name].breadcrumbs;
// export const getSearchQuery = (state: RootState) => state[slice.name].searchQuery;
// export const getSearchResults = (state: RootState) => state[slice.name].searchResults;
// export const getIsSearching = (state: RootState) => state[slice.name].isSearching;
// export const getStatistics = (state: RootState) => state[slice.name].statistics;
// export const getViewMode = (state: RootState) => state[slice.name].viewMode;
// export const getSortBy = (state: RootState) => state[slice.name].sortBy;
// export const getSortOrder = (state: RootState) => state[slice.name].sortOrder;
